import React, { useState, useRef, useEffect, useContext } from 'react'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { Button, Menu, MenuItem, Tooltip, useMediaQuery } from '@mui/material'
import './member.css'
import { useTheme } from '@emotion/react'
import {
    capitalize,
    currencyFormat,
    dateFormatFront,
    dateFormatFrontOnlyDate,
    dateTimeFormatFunction,
} from '@/custom/common/components'
import Timer from '@/product/common/timer'
import ReturnContext from '@/custom/context/return/returnContext'
import { isValidHttpUrl } from '@/product/common/components'
import AlertContext from '@/product/context/alert/alertContext'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import { useHistory } from 'react-router-dom'
import ProductContext from '@/product/context/product/productContext'

const CardItem = (props) => {
    const history = useHistory()
    const invoiceContext = useContext(InvoiceContext)
    const isMobile = useMediaQuery('(max-width:767px)')
    const CustomTooltip = Tooltip
    const {
        all_invoices,
        getAllInvoices,
        responseStatus: responseStatusInvoice,
    } = invoiceContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const returncontext = useContext(ReturnContext)
    const {
        updateRequest,
        responseStatus: responseStatusRequest,
        clearResponse: clearResponseRequest,
    } = returncontext
    const productContext = useContext(ProductContext)
    const {
        changeProductStatus,
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext

    const { allLocations } = useContext(CustomCommonContext)

    const [isLoading, setIsLoading] = useState(true)
    const [anchorBreakEl, setAnchorBreakEl] = useState(false)
    const theme = useTheme()
    const [product, setProduct] = useState({})
    const [productLocation, setProductLocation] = useState({})
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const handleBreakClose = () => {
        setAnchorBreakEl(null)
    }
    const handleBreakClick = (event) => {
        setAnchorBreakEl(event.currentTarget)
    }
    const [expanded, setExpanded] = React.useState(
        props.defaultPanel ? props.defaultPanel : 'panel0'
    )

    const checkDateReached = (data, reverse) => {
        const inputDate = new Date(data)
        const currentDate = new Date()
        //For checking date alone
        inputDate.setHours(0, 0, 0, 0)
        currentDate.setHours(0, 0, 0, 0)
        if ((reverse && inputDate >= currentDate) || currentDate > inputDate) {
            return true
        } else {
            return false
        }
    }

    const relistProduct = (data) => {
        changeProductStatus({
            action: 'relist',
            mainUpdate: false,
            project_id: [data.project_id],
        })
    }

    useEffect(() => {
        if (responseStatusProduct) {
            if (responseStatusProduct.status === 'success') {
                if (responseStatusProduct.from === 'productchange') {
                    setChangeStatus(false)
                    props.updateFunction()
                }
            }
            clearResponseProduct()
        }
    }, [responseStatusProduct])
    //  const { tooltipStates, toggleTooltip } = useTooltipManager({
    //     return: null,
    //     returnDue: null,
    //     pickup: null,
    //     blank: null,
    //     unCollected: null,
    //     itemReturned: null,
    //     pickedUp: null,
    // })
    const zeeFeeBubble = (
        <>
            <p className="mb-1">
                A 15% fee is applied to the original sale price of each item to
                support the maintenance and operations of the zipperbuy system.
                This fee ensures we can continue providing a high-quality,
                secure, and user-friendly platform for all our members.
            </p>
            <p className="learnMore mb-0">Learn more</p>
            <a
                href={'/terms-and-conditions'}
                target="_blank"
                rel="noreferrer"
                className="cursor-pointer"
            >
                <span className="terms">Terms & Conditions</span>
            </a>
        </>
    )
    useEffect(() => {
        if (responseStatusRequest) {
            if (
                responseStatusRequest &&
                responseStatusRequest.from == `update${product?.projects_id}`
            ) {
                if (
                    responseStatusRequest?.message !==
                    'Return Status Changed Successfully'
                ) {
                    setAlert(
                        responseStatusRequest.message,
                        responseStatusRequest.status
                    )
                }
                props.updateFunction()
                clearResponseRequest()
            }
        }
    }, [responseStatusRequest])
    useEffect(() => {
        setProduct({})
        setProductLocation({})
        if (props?.data?.id || props?.data?.projects_id) {
            setProduct(props.data)

            if (props?.data?.projects_location_id) {
                setProductLocation(
                    allLocations?.filter(
                        (item) =>
                            item?.id ===
                            parseInt(props.data.projects_location_id)
                    )[0] || {}
                )
            }
            // notesFormik.setFieldValue('project_id', props?.data?.project_id)
            // notesFormik.setFieldValue('getUser', true)
            // if (props?.data?.user_projects_notes_id) {
            //     notesFormik.setFieldValue('id', props?.data?.user_projects_notes_id)
            //     notesFormik.setFieldValue('notes', props?.data?.user_projects_notes_notes)
            // }
        }
    }, [props.data])

    return (
        <>
            {product?.projects_id ? (
                <div className="cartItem d-flex justify-content-between align-items-stretch">
                    <div className="product-view-wrapper itemInfo d-flex justify-content-start">
                        <div className="pclImg">
                            <img
                                src={
                                    isValidHttpUrl(product.projects_avatar)
                                        ? product.projects_avatar
                                        : global.site_url +
                                          '/uploads/product/' +
                                          product.projects_avatar
                                }
                                alt={product.projects_title}
                                onError={(e) =>
                                    (e.target.src =
                                        '/assets/images/noimage.png')
                                }
                            />
                            {product?.id && !product?.paid ? (
                                <small className="d-flex justify-content-center align-items-center ml-unpaid">
                                    Unpaid
                                </small>
                            ) : null}
                        </div>
                        <div className="mem-list-content">
                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                <a
                                    href={`${process.env.REACT_APP_FRONTEND_URL}product-view/${product?.projects_id}`}
                                    className="lot-id"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {product?.projects_title}
                                </a>
                            </div>
                            <div className="text-left mt-3 flex-wrap ci-details">
                                {productLocation?.full_address ? (
                                    <b className="pickupLabel">
                                        Pickup Location :
                                    </b>
                                ) : null}
                                {productLocation?.full_address ? (
                                    <a
                                        className="get-directions-link"
                                        target="_blank"
                                        href={`https://www.google.com/maps/place/?q=place_id:${
                                            productLocation?.place_id || ''
                                        }`}
                                        rel="noreferrer"
                                    >
                                        {productLocation?.full_address || ''}
                                    </a>
                                ) : null}{' '}
                                {product?.custom_projects_bin_location ||
                                product?.projects_item_id ? (
                                    <span className="PathStep">
                                        {product?.custom_projects_bin_location
                                            ? `${product?.custom_projects_bin_location}`
                                            : ''}
                                        {product?.projects_item_id
                                            ? ` > ${product?.projects_item_id}`
                                            : ''}
                                    </span>
                                ) : null}
                            </div>
                            {!isMobile && (
                                <div className="cartInfo mt-3 d-flex align-items-center memberCartInfo">
                                    <Button
                                        onClick={() =>
                                            props?.handleMoveItem
                                                ? props.handleMoveItem(
                                                      true,
                                                      product?.projects_id,
                                                      product?.custom_projects_bin_location
                                                  )
                                                : null
                                        }
                                    >
                                        Move Item
                                    </Button>
                                    {product.return_request_status == 2 ? (
                                        <Button
                                            // onClick={() =>
                                            //     props.handlePendingReturn(
                                            //         product?.projects_id,
                                            //         product.common_invoice,
                                            //         product?.id
                                            //     )
                                            // }
                                            onClick={() => {
                                                if (
                                                    product.return_due_date &&
                                                    checkDateReached(
                                                        product.return_due_date,
                                                        true
                                                    )
                                                ) {
                                                    props.handlePendingReturn(
                                                        product?.projects_id,
                                                        product.common_invoice,
                                                        product?.id
                                                    )
                                                }
                                            }}
                                            disabled={
                                                !product.return_due_date &&
                                                !checkDateReached(
                                                    product.return_due_date,
                                                    true
                                                )
                                            }
                                        >
                                            Start Return
                                        </Button>
                                    ) : null}
                                    <Button
                                        onClick={() =>
                                            handleRedirectInternal(
                                                history,
                                                `listing/edit/${product?.projects_id}`
                                            )
                                        }
                                    >
                                        More Item Details
                                    </Button>
                                    {product?.qty && (
                                        <>
                                            <div className="quantity">
                                                <span>QTY :</span>
                                                <span>{product?.qty}</span>
                                            </div>{' '}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    {isMobile && (
                        <div className="cartInfo mt-3 d-flex align-items-center memberCartInfo">
                            <Button
                                onClick={() =>
                                    props?.handleMoveItem
                                        ? props.handleMoveItem(
                                              true,
                                              product?.projects_id,
                                              product?.custom_projects_bin_location
                                          )
                                        : null
                                }
                            >
                                Move Item
                            </Button>
                            {product.return_request_status == 2 ? (
                                <Button
                                    onClick={() => {
                                        if (
                                            product.return_due_date &&
                                            checkDateReached(
                                                product.return_due_date,
                                                true
                                            )
                                        ) {
                                            props.handlePendingReturn(
                                                product?.projects_id,
                                                product.common_invoice,
                                                product?.id
                                            )
                                        }
                                    }}
                                    disabled={
                                        !product.return_due_date &&
                                        !checkDateReached(
                                            product.return_due_date,
                                            true
                                        )
                                    }
                                >
                                    Start Return
                                </Button>
                            ) : null}
                            <Button
                                onClick={() =>
                                    handleRedirectInternal(
                                        history,
                                        `listing/edit/${product?.projects_id}`
                                    )
                                }
                            >
                                More Item Details
                            </Button>
                            {product?.qty && (
                                <>
                                    <div className="quantity">
                                        <span>QTY :</span>
                                        <span>{product?.qty}</span>
                                    </div>{' '}
                                </>
                            )}
                        </div>
                    )}
                    <div
                        className={`text-center position-relative cartPrdPrice d-flex flex-column ${
                            product.return_request_status === 4 ||
                            product.projects_market_status === 'draft' ||
                            product.projects_market_status === 'open'
                                ? 'align-items-center'
                                : ''
                        }`}
                    >
                        <div className="cart-price-top">
                            {product.return_request_status !== 4 &&
                            product.return_request_status !== 3 ? (
                                <div className="cp-top">
                                    {!product?.id ? (
                                        <div
                                            className="cart-price"
                                            style={{
                                                fontSize: '24px',
                                                fontWeight: 'bold',
                                                color: '#4A4A4A',
                                            }}
                                        >
                                            {currencyFormat(
                                                product.projects_wprice >
                                                    product.projects_bprice
                                                    ? product.projects_wprice
                                                    : product.projects_bprice
                                            )}
                                        </div>
                                    ) : (
                                        <div className="cart-price">
                                            {currencyFormat(
                                                // product?.coupon_discount > 0 && product?.credit_discount > 0
                                                //     ? _.sum([
                                                //           product?.total_amount_after_discount || product?.total_amount,
                                                //           product?.credit_discount || 0,
                                                //       ])
                                                //     : product?.coupon_discount > 0
                                                //     ? product?.total_amount
                                                //     : product?.credit_discount > 0
                                                //     ? _.sum([
                                                //           product?.total_amount_after_discount || product?.total_amount,
                                                //           product?.credit_discount || 0,
                                                //       ])
                                                //     : product?.total_amount_after_discount || product?.total_amount,
                                                product?.coupon_discount > 0 &&
                                                    product?.credit_discount >
                                                        0 &&
                                                    !product?.total_amount_after_discount
                                                    ? _.subtract(
                                                          product?.total_amount,
                                                          product?.coupon_discount ||
                                                              0
                                                      )
                                                    : product?.credit_discount >
                                                            0 &&
                                                        product?.total_amount_after_discount
                                                      ? _.sum([
                                                            product?.total_amount_after_discount,
                                                            product?.credit_discount ||
                                                                0,
                                                        ])
                                                      : product?.credit_discount >
                                                              0 &&
                                                          !product?.total_amount_after_discount
                                                        ? product?.credit_discount ||
                                                          0
                                                        : product?.coupon_discount >
                                                            0
                                                          ? product?.total_amount_after_discount
                                                          : product?.total_amount_after_discount ||
                                                            product?.total_amount,
                                                2
                                            )}
                                        </div>
                                    )}

                                    {!product?.id ? (
                                        <div
                                            className="breakdown text-md-right text-center"
                                            style={{ marginTop: '8px' }}
                                        >
                                            {product.projects_wprice >
                                            product.projects_bprice ? (
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#A0A0A0',
                                                    }}
                                                >
                                                    Current Offer
                                                </span>
                                            ) : product.projects_bprice ? (
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#A0A0A0',
                                                    }}
                                                >
                                                    Buy Now
                                                </span>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    ) : (
                                        <div className="breakdown text-md-right text-left">
                                            <Button
                                                className="pr-0"
                                                onClick={handleBreakClick}
                                            >
                                                breakdown
                                                <span className="material-icons">
                                                    keyboard_arrow_down
                                                </span>
                                            </Button>
                                            <Menu
                                                id="simple-break-menu"
                                                anchorEl={anchorBreakEl}
                                                open={Boolean(anchorBreakEl)}
                                                onClose={handleBreakClose}
                                                className="pgShare"
                                            >
                                                <MenuItem>
                                                    <span>
                                                        {product?.source_type ===
                                                        'buynow'
                                                            ? 'Buy Now Price'
                                                            : 'Won Offer'}
                                                        :
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.per_total,
                                                            2
                                                        )}
                                                    </span>
                                                </MenuItem>
                                                {/* <MenuItem>
                                                    <span>{'Won Offer'}:</span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.per_total
                                                        )}
                                                    </span>
                                                </MenuItem> */}
                                                {/* <MenuItem>
                                                    <span>
                                                        {'ZB Fee'}(
                                                        {
                                                            product.buyer_premium_percent
                                                        }
                                                        %):{' '}
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.total_premium
                                                        )}
                                                    </span>
                                                </MenuItem> */}
                                                <MenuItem>
                                                    <span>
                                                        {'ZB Fee'} (
                                                        {
                                                            product.buyer_premium_percent
                                                        }
                                                        %):{' '}
                                                        {/* <CustomTooltip
                                    id="blank"
                                    title={zeeFeeBubble}
                                    tooltipState={tooltipStates.blank}
                                    onToggle={toggleTooltip}
                                    placement="top"
                                    arrow={false}
                                >
                                    <img className="infoIcon" src="/assets/svg/Info.svg" />
                                </CustomTooltip> */}
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.total_premium,
                                                            2
                                                        )}
                                                    </span>
                                                </MenuItem>
                                                {product?.coupon_discount ? (
                                                    <MenuItem>
                                                        <span>
                                                            Promo Discount :
                                                        </span>
                                                        <span>
                                                            -{' '}
                                                            {currencyFormat(
                                                                product.coupon_discount,
                                                                2
                                                            )}
                                                        </span>
                                                    </MenuItem>
                                                ) : null}

                                                <MenuItem>
                                                    <span>
                                                        {'Tax'} (
                                                        {product.tax_percent}%):
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.total_tax,
                                                            2
                                                        )}
                                                    </span>
                                                </MenuItem>

                                                {/* Wallet Discount */}
                                                {product?.credit_discount ? (
                                                    <MenuItem>
                                                        <span>
                                                            {'Wallet Discount'}:
                                                        </span>
                                                        <span>
                                                            {' '}
                                                            {currencyFormat(
                                                                product.credit_discount,
                                                                2
                                                            )}
                                                        </span>
                                                    </MenuItem>
                                                ) : null}
                                                {product?.card_discount ? (
                                                    <MenuItem>
                                                        <span>
                                                            {'Card Paid'}:
                                                        </span>
                                                        <span>
                                                            {' '}
                                                            {currencyFormat(
                                                                product.card_discount,
                                                                2
                                                            )}
                                                        </span>
                                                    </MenuItem>
                                                ) : null}

                                                <MenuItem>
                                                    <span>{'Total'}:</span>
                                                    <span>
                                                        {currencyFormat(
                                                            product?.coupon_discount >
                                                                0 &&
                                                                product?.credit_discount >
                                                                    0 &&
                                                                !product?.total_amount_after_discount
                                                                ? _.subtract(
                                                                      product?.total_amount,
                                                                      product?.coupon_discount ||
                                                                          0
                                                                  )
                                                                : product?.credit_discount >
                                                                        0 &&
                                                                    product?.total_amount_after_discount
                                                                  ? _.sum([
                                                                        product?.total_amount_after_discount,
                                                                        product?.credit_discount ||
                                                                            0,
                                                                    ])
                                                                  : product?.credit_discount >
                                                                          0 &&
                                                                      !product?.total_amount_after_discount
                                                                    ? product?.credit_discount ||
                                                                      0
                                                                    : product?.coupon_discount >
                                                                        0
                                                                      ? product?.total_amount_after_discount
                                                                      : product?.total_amount_after_discount ||
                                                                        product?.total_amount,
                                                            2
                                                        )}
                                                    </span>
                                                </MenuItem>
                                                {/* <MenuItem>
                                                    <span>
                                                        {'Tax'}(
                                                        {product.tax_percent}%):
                                                    </span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.total_tax
                                                        )}
                                                    </span>
                                                </MenuItem> */}
                                                {/* <MenuItem>
                                                    <span>{'Total'}:</span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.total_amount
                                                        )}
                                                    </span>
                                                </MenuItem> */}
                                            </Menu>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="cc-price-div"></div>
                            )}
                        </div>
                        <div className="cart-btm">
                            <div className="text-right position-relative cartPrdPrice">
                                {product.return_request_status === 2 ? (
                                    <Button
                                        className="cartBtn"
                                        onClick={() => {
                                            if (
                                                product.return_due_date &&
                                                checkDateReached(
                                                    product.return_due_date,
                                                    true
                                                )
                                            ) {
                                                props.handlePendingReturn(
                                                    product?.projects_id,
                                                    product.common_invoice,
                                                    product?.id
                                                )
                                            }
                                        }}
                                        disabled={
                                            !product.return_due_date &&
                                            !checkDateReached(
                                                product.return_due_date,
                                                true
                                            )
                                        }
                                    >
                                        Pending Return
                                    </Button>
                                ) : product.return_request_status === 3 ? (
                                    <Button
                                        className="cartBtn refunded"
                                        // disabled={true}
                                        onClick={() => {
                                            props.handlePendingReturn(
                                                product?.projects_id,
                                                product.common_invoice,
                                                product?.id,
                                                'relist'
                                            )
                                        }}
                                    >
                                        Returned
                                    </Button>
                                ) : product.return_request_status === 0 &&
                                  !product.restocking_fee ? (
                                    <Button
                                        className="cartBtn markPickedUp"
                                        onClick={() => {
                                            if (
                                                product.pickup_deadline &&
                                                !checkDateReached(
                                                    product.pickup_deadline
                                                )
                                            ) {
                                                updateRequest(
                                                    {
                                                        project_id:
                                                            product?.projects_id,
                                                        return_request_status: 1,
                                                        chnageStatus: true,
                                                        bid: product?.id,
                                                    },
                                                    `update${product?.projects_id}`
                                                )
                                            }
                                        }}
                                        disabled={
                                            (product.pickup_deadline &&
                                                checkDateReached(
                                                    product.pickup_deadline
                                                )) ||
                                            !product?.paid
                                        }
                                    >
                                        Mark Picked Up
                                    </Button>
                                ) : product.return_request_status === 1 ? (
                                    <Button
                                        className="cartBtn mark-npicked"
                                        disabled={
                                            product.pickup_deadline &&
                                            !checkDateReached(
                                                product.pickup_deadline
                                            )
                                                ? false
                                                : true
                                        }
                                        onClick={() => {
                                            if (
                                                product.pickup_deadline &&
                                                !checkDateReached(
                                                    product.pickup_deadline
                                                )
                                            ) {
                                                updateRequest(
                                                    {
                                                        project_id:
                                                            product?.projects_id,
                                                        return_request_status: 0,
                                                        chnageStatus: true,
                                                        bid: product?.id,
                                                    },
                                                    `update${product?.projects_id}`
                                                )
                                            }
                                        }}
                                    >
                                        Mark Not Picked Up
                                    </Button>
                                ) : product.paid == 0 &&
                                  product.projects_market_status ==
                                      'relisted' &&
                                  product.projects_relisted_id > 0 ? (
                                    <Button
                                        className="cartBtn draftcardbtn"
                                        disabled={true}
                                    >
                                        Draft Inventory
                                    </Button>
                                ) : // : product.return_request_status === 0 &&
                                //   //   !product.paid &&
                                //   product.pickup_deadline &&
                                //   checkDateReached(product.pickup_deadline) ? (
                                //     <Button
                                //         className="cartBtn relistcardBtn"
                                //         onClick={() => {
                                //             if (
                                //                 product.pickup_deadline &&
                                //                 checkDateReached(
                                //                     product.pickup_deadline
                                //                 )
                                //             ) {
                                //                 relistProduct(product)
                                //             }
                                //         }}
                                //         disabled={
                                //             !product.pickup_deadline &&
                                //             !checkDateReached(
                                //                 product.pickup_deadline
                                //             )
                                //         }
                                //     >
                                //         Needs Relisted
                                //     </Button>
                                // )
                                product.return_request_status === 0 &&
                                  !product.paid ? (
                                    // <Button
                                    //     className="cartBtn markcardBtn"
                                    //     disabled={true}
                                    // >
                                    //     Mark Picked Up
                                    // </Button>
                                    <Button
                                        className="cartBtn livecardBtn"
                                        disabled={true}
                                    >
                                        Live
                                    </Button>
                                ) : product.return_request_status === 4 ? (
                                    <Button
                                        className="cartBtn relistcardBtn"
                                        // disabled={true}
                                        onClick={() => {
                                            props.handleNeedRelist(
                                                product?.projects_id,
                                                product?.user_id
                                            )
                                        }}
                                    >
                                        Needs Relisted
                                    </Button>
                                ) : product.projects_market_status === 'open' &&
                                  !product.id ? (
                                    <Button
                                        className="cartBtn livecardBtn"
                                        disabled={true}
                                    >
                                        Live
                                    </Button>
                                ) : product.projects_market_status ===
                                      'draft' && !product.id ? (
                                    <Button
                                        className="cartBtn draftcardbtn"
                                        disabled={true}
                                    >
                                        Draft Inventory
                                    </Button>
                                ) : (
                                    <Button className="cartBtn" disabled={true}>
                                        Unknown
                                    </Button>
                                )}
                            </div>
                            <div className="cartStatus mt-1">
                                {product.return_request_status === 2 ? (
                                    <div className="d-flex w-full justify-content-center align-items-center">
                                        <p className="mb-0">
                                            Return By{' '}
                                            {dateFormatFrontOnlyDate(
                                                product?.return_due_date
                                            )}
                                        </p>
                                        <div className="tt-wrap">
                                            <Tooltip
                                                title="Item must be returned by this date."
                                                placement="right"
                                                className="infoImage"
                                                arrow
                                                enterTouchDelay={0}
                                                leaveTouchDelay={5000}
                                            >
                                                <span
                                                    className="material-icons-outlined"
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    info
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                ) : product.return_request_status === 3 ? (
                                    <div className="d-flex w-full justify-content-center align-items-center">
                                        <p className="mb-0">
                                            Returned On{' '}
                                            {dateFormatFrontOnlyDate(
                                                product?.refund_date
                                            )}
                                        </p>
                                        <div className="tt-wrap">
                                            <Tooltip
                                                title={`Item was returned at ${dateTimeFormatFunction(
                                                    product?.refund_date,
                                                    'hh:mm A'
                                                )}`}
                                                placement="right"
                                                className="infoImage"
                                                arrow
                                            >
                                                <span className="material-icons-outlined">
                                                    info
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                ) : product.return_request_status === 1 ? (
                                    <div className="d-flex w-full justify-content-center align-items-center">
                                        <p className="mb-0">
                                            Picked Up{' '}
                                            {dateFormatFrontOnlyDate(
                                                product?.picked_up_date
                                            )}
                                        </p>
                                        <div className="tt-wrap">
                                            <Tooltip
                                                title={`Picked up at ${dateTimeFormatFunction(
                                                    product?.picked_up_date,
                                                    'hh:mm A'
                                                )}`}
                                                placement="right"
                                                className="infoImage"
                                                arrow
                                            >
                                                <span className="material-icons-outlined">
                                                    info
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                ) : product.return_request_status === 0 ? (
                                    <div className="d-flex w-full justify-content-center align-items-center">
                                        <p className="mb-0">
                                            Pick Up Deadline{' '}
                                            {dateFormatFrontOnlyDate(
                                                product?.pickup_deadline
                                            )}
                                        </p>
                                        <div className="tt-wrap">
                                            <Tooltip
                                                title="This is the final date to pay for and pickup your item. If items are not paid for and picked up by the deadline, a restocking fee will be applied, and the items will be considered abandoned. Please note that no refunds will be issued for abandoned items."
                                                placement="right"
                                                className="infoImage"
                                                arrow
                                            >
                                                <span className="material-icons-outlined">
                                                    info
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    )
}
export default CardItem
